import * as React from 'react';

import classNames from 'classnames';

import { TooltipWrapper } from 'bundles/common/components/Tooltip';
import { CrossBrowserFullscreenUtils } from 'bundles/video-player';

import _t from 'i18n!nls/videojs';

import 'css!./__styles__/FullscreenToggle';

type Props = {
  onChangeFullScreen: (isFullscreen: boolean) => void;
};

function FullscreenToggle(props: Props) {
  const isFullscreen = CrossBrowserFullscreenUtils.isFullScreen();

  const label = isFullscreen ? _t('Exit full Screen') : _t('Full Screen');

  // NOTE: continuing to use the VJS skin styles for now
  // once we get stuff into React we can migrate the skin
  return (
    <TooltipWrapper placement="top" message={label}>
      <button
        type="button"
        onClick={() => {
          props.onChangeFullScreen(isFullscreen);
        }}
        className={classNames(
          'rc-FullscreenToggle',
          'vjs-button',
          'c-vjs-button',
          'vjs-control',
          'c-video-control',
          'c-fullscreen-control',
          'horizontal-box',
          'align-items-absolute-center'
        )}
        aria-label={label}
        aria-expanded={isFullscreen}
      >
        <span
          className={classNames('cif-2x', 'cif-fw', {
            'cif-expand': !isFullscreen,
            'cif-compress': isFullscreen,
          })}
        />
        <span className="vjs-control-text"> {label} </span>
      </button>
    </TooltipWrapper>
  );
}
export default FullscreenToggle;
